import React, { Component } from 'react';
import ReactSlider from 'react-slider';
import style from './SliderControl.css';
import { getApp } from '../../App';

class SliderControl extends Component {
  componentDidMount() {
    this.terrainProfile = getApp().terrainProfile;
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return this.props.maxDistance === 0 ? null : (
      <div className={style.layout}>
        <ReactSlider
          className={style.input}
          handleClassName={style.handle}
          min={0}
          max={1}
          withBars
          onBeforeChange={percent => this.terrainProfile.onScrubStart(getAdjustedPercent(percent))}
          onAfterChange={percent => this.terrainProfile.onScrubEnd(getAdjustedPercent(percent))}
          onChange={percent => this.terrainProfile.onScrub(getAdjustedPercent(percent))}
          step={0.000000005}
        />
      </div>
    );
  }
}

function getAdjustedPercent(percent) {
  return (percent * window.innerWidth + 7.5) / window.innerWidth;
}

export default SliderControl;
